import styled from 'styled-components'
import Link from 'next/link'

export const theme = {
  colors: {
    green1: '#6A8520',
    white1: '#FFFFFF',
    black1: 'black',
    grey1: '#DDE0E3',
    grey2: '#F6F6F7',
    grey3: '#F3F3F3',
  },
  fonts: {
    primary: {
      light: 'MierA-Light, "Helvetica Neue"',
      regular: 'MierA-Regular, "Helvetica Neue"',
      heavy: 'MierA-Bold, "Helvetica Neue"',
    },
  },
}

export const StyledAnchor = styled.a`
  display: flex;
  justify-content: center;
  text-decoration: none;
  align-items: flex-end;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
  font-family: ${props => props.theme.fonts.primary.regular};
  color: ${props => props.theme.colors.black1};
  font-size: 12pt;
`
